import { JSDOM } from "jsdom";
import WebSocket from "ws";
import { Image as CanvasImage } from "canvas";
import { LocalStorage } from "node-localstorage";

const DOM = new JSDOM(
    "<!DOCTYPE html><html><body><p>Placeholder</p></body></html>",
    {
        url: "http://localhost",
    },
);

/**
 * NodeRainbowSDK provides browser environment simulation for Rainbow SDK in Node.js
 */
export class NodeRainbowSDK {
    /**
     * Initializes the Node.js environment with browser-like globals
     * @returns
     */
    public async initNode(): Promise<void> {
        this.setDOM();
        this.setEvent();
        this.setLocalstorage();
        this.setWebsocket();
        this.setImage();
        this.setGlobals();
    }

    /**
     * Sets up DOM-related globals on globalThis
     * @returns
     */
    private setDOM(): void {
        // DOM globals
        (globalThis as any).window = DOM.window;
        globalThis.document = DOM.window.document;
        globalThis.DOMParser = DOM.window.DOMParser;
        globalThis.XMLSerializer = DOM.window.XMLSerializer;
        Object.defineProperty(globalThis, "navigator", {
            value: DOM.window.navigator,
            writable: true,
            configurable: true });
    }

    /**
     * Sets up event-related globals on globalThis
     * @returns
     */
    private setEvent(): void {
        // Eventtarget
        globalThis.Event = DOM.window.Event;
        globalThis.EventTarget = DOM.window.EventTarget;
    }

    /**
     * Sets up localStorage global on globalThis
     * @returns
     */
    private setLocalstorage(): void {
        // Localstorage
        globalThis.localStorage = new LocalStorage("./scratch");
    }

    /**
     * Sets up WebSocket global on globalThis
     * @returns
     */
    private setWebsocket(): void {
        // Websocket
        (globalThis as any).WebSocket = WebSocket;
    }

    /**
     * Sets up Image global on globalThis using canvas
     * @returns
     */
    private setImage(): void {
        // Image object
        (globalThis as any).Image = CanvasImage;
    }

    /**
     * Sets up miscellaneous global variables needed by Rainbow SDK
     * @returns
     */
    private setGlobals(): void {
        // Global variables RainbowSDK
        (globalThis as any).config = {};
        (globalThis as any).version = "Nothing";
    }
}

function isBrowser(): boolean {
    return ![typeof window, typeof document].includes("undefined");
}

if (!isBrowser()) {
    console.log("Node detected, initializing");
    new NodeRainbowSDK().initNode();
}
